import { render, staticRenderFns } from "./single_image.vue?vue&type=template&id=c4910650&scoped=true&"
import script from "./single_image.vue?vue&type=script&lang=js&"
export * from "./single_image.vue?vue&type=script&lang=js&"
import style0 from "./single_image.vue?vue&type=style&index=0&id=c4910650&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4910650",
  null
  
)

export default component.exports